import axios from 'axios';
const balanceCheckerForm = document.querySelector('[data-balance-checker="form"]');
if (balanceCheckerForm) {
    const balanceCheckerNumberInput = balanceCheckerForm.querySelector('[data-balance-checker="number"]');
    const balanceCheckerPinInput = balanceCheckerForm.querySelector('[data-balance-checker="pin"]');
    const balanceCheckerResult = balanceCheckerForm.querySelector('[data-balance-checker="result"]');
    const updateResult = (message, isError) => {
        balanceCheckerResult.classList.remove('balance-checker__result--error');
        balanceCheckerResult.classList.remove('balance-checker__result--success');
        balanceCheckerResult.innerHTML = message;
        if (!!message.length) {
            balanceCheckerResult.classList.add(`balance-checker__result--${isError ? 'error' : 'success'}`);
        }
    };
    const CARD_NUMBER_LENGTH = parseInt(balanceCheckerForm.dataset.balanceCheckerCardLength, 10);
    const GIFT_CARD_PIN_REQUIRED = balanceCheckerForm.dataset.balanceCheckerPinRequired === 'true';
    const PIN_NUMBER_LENGTH = parseInt(balanceCheckerForm.dataset.balanceCheckerPinLength, 10);
    const SHOP_SUBDOMAIN = balanceCheckerForm.dataset.balanceCheckerShopSubdomain;
    const API_ENDPOINT = balanceCheckerForm.dataset.balanceCheckerApiEndpoint;
    const ERROR_INVALID_INFORMATION = balanceCheckerForm.dataset.balanceCheckerErrorInvalidInformation;
    const ERROR_GENERAL = balanceCheckerForm.dataset.balanceCheckerErrorGeneral;
    const SUCCESS_MESSAGE = balanceCheckerForm.dataset.balanceCheckerSuccessMessage;
    balanceCheckerForm.addEventListener('submit', (event) => {
        event.preventDefault();
        console.log('Form submitted');
        // Perform initial validation before passing to API.
        if ((balanceCheckerNumberInput.value.length !== CARD_NUMBER_LENGTH) || (GIFT_CARD_PIN_REQUIRED && (balanceCheckerPinInput.value.length) !== PIN_NUMBER_LENGTH)) {
            updateResult(ERROR_INVALID_INFORMATION, true);
            return;
        }
        console.log('Form submitted, API call');
        updateResult('', false);
        const apiUrl = `${API_ENDPOINT}/${SHOP_SUBDOMAIN}/cards/${balanceCheckerNumberInput.value}.json`;
        axios.get(apiUrl, {
            params: {
                pin: GIFT_CARD_PIN_REQUIRED ? balanceCheckerPinInput.value : null
            }
        })
            .then((response) => {
            updateResult(SUCCESS_MESSAGE
                .replace('<balance_formatted>', response.data.card.balance_formatted)
                .replace('<expires_at_formatted>', response.data.card.expires_at_formatted), false);
        })
            .catch((data) => {
            console.error(data);
            updateResult(ERROR_GENERAL, true);
        });
    });
}
